import React from "react";

/**
 * Logos des cartes bancaires acceptées (Visa, Mastercard) + sécurisation CMI.
 *
 * Affiché dans le footer et sur la page « Paiement sécurisé » afin d'indiquer
 * clairement au client les moyens de paiement acceptés (exigence CMI).
 * Logos en SVG inline : aucun téléchargement d'image, rendu net sur tout écran.
 */
export default function PaymentCards({ className = "", showLabel = true, language = "fr" }) {
  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      {showLabel && (
        <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/50">
          {language === "fr" ? "Paiement sécurisé par carte" : "Secure card payment"}
        </span>
      )}
      <div className="flex items-center gap-2">
        {/* Visa */}
        <svg
          viewBox="0 0 48 30"
          role="img"
          aria-label="Visa"
          className="h-7 w-auto rounded bg-white shadow-sm"
        >
          <rect width="48" height="30" rx="4" fill="#fff" />
          <text
            x="24"
            y="20"
            textAnchor="middle"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="14"
            fontStyle="italic"
            fontWeight="bold"
            fill="#1A1F71"
            letterSpacing="0.5"
          >
            VISA
          </text>
        </svg>

        {/* Mastercard */}
        <svg
          viewBox="0 0 48 30"
          role="img"
          aria-label="Mastercard"
          className="h-7 w-auto rounded bg-white shadow-sm"
        >
          <rect width="48" height="30" rx="4" fill="#fff" />
          <circle cx="20" cy="15" r="8" fill="#EB001B" />
          <circle cx="28" cy="15" r="8" fill="#F79E1B" />
          <path d="M24 9.2a8 8 0 0 0 0 11.6 8 8 0 0 0 0-11.6z" fill="#FF5F00" />
        </svg>

        {/* CMI */}
        <span className="inline-flex h-7 items-center rounded bg-white px-2 text-[11px] font-extrabold tracking-wide text-[#0a3d62] shadow-sm">
          CMI
        </span>
      </div>
    </div>
  );
}
